/**
 * Pause media-text autoplay video / embeds while the section is off-screen.
 */
(function () {
  /**
   * @param {HTMLElement} root
   */
  function bind(root) {
    if (root.dataset.viewportMediaBound === 'true') return;
    root.dataset.viewportMediaBound = 'true';

    if (window.Shopify && window.Shopify.designMode) return;
    if (typeof IntersectionObserver === 'undefined') return;

    var video = root.querySelector('video.media-text__video');
    var iframe = root.querySelector('iframe.media-text__embed');
    if (!video && !iframe) return;

    var wantsAutoplay = false;
    if (video instanceof HTMLVideoElement) {
      wantsAutoplay = video.autoplay || video.hasAttribute('autoplay');
    } else if (iframe instanceof HTMLIFrameElement) {
      wantsAutoplay = /[?&]autoplay=1/.test(iframe.src || '');
    }
    if (!wantsAutoplay) return;

    /**
     * @param {boolean} play
     */
    function setPlayback(play) {
      if (video instanceof HTMLVideoElement) {
        if (play) {
          video.play().catch(function () {});
        } else {
          video.pause();
        }
        return;
      }

      if (!(iframe instanceof HTMLIFrameElement) || !iframe.contentWindow) return;

      var isYoutube = /youtube\.com|youtu\.be/.test(iframe.src);
      iframe.contentWindow.postMessage(
        isYoutube
          ? JSON.stringify({
              event: 'command',
              func: play ? 'playVideo' : 'pauseVideo',
              args: '',
            })
          : JSON.stringify({ method: play ? 'play' : 'pause' }),
        '*'
      );
    }

    var observer = new IntersectionObserver(
      function (entries) {
        var visible = entries.some(function (entry) {
          return entry.isIntersecting;
        });
        setPlayback(visible);
      },
      { threshold: 0.15 }
    );

    observer.observe(root);
  }

  function boot() {
    document.querySelectorAll('.media-text').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector?.('.media-text') || (event.target.matches?.('.media-text') ? event.target : null);
    if (root) bind(root);
  });
})();
